export default "__VITE_ASSET__FXVgbn8m__"